import { Reveal, Eyebrow } from "./Reveal";

const Node = ({ x, y, accent = false, label }) => (
    <g>
        {accent && (
            <circle
                cx={x}
                cy={y}
                r="5"
                fill="none"
                stroke="#2563EB"
                strokeWidth="1"
                className="animate-ping-soft"
                style={{ transformBox: "fill-box", transformOrigin: "center" }}
            />
        )}
        <circle cx={x} cy={y} r={accent ? 4 : 3} fill={accent ? "#2563EB" : "#94A3B8"} />
        {label && (
            <text x={x + 12} y={y + 4} fill="#64748B" fontSize="10" fontFamily="JetBrains Mono, monospace" letterSpacing="2">
                {label}
            </text>
        )}
    </g>
);

const NetworkVisual = () => (
    <svg viewBox="0 0 560 440" className="h-auto w-full" role="img" aria-label="Abstract network map showing connections radiating from India">
        <circle cx="200" cy="240" r="70" fill="none" stroke="#BFDBFE" strokeDasharray="3 6" />
        <circle cx="200" cy="240" r="130" fill="none" stroke="#BFDBFE" strokeDasharray="3 6" />
        <circle cx="200" cy="240" r="190" fill="none" stroke="#BFDBFE" strokeDasharray="3 6" />
        <ellipse cx="200" cy="240" rx="70" ry="190" fill="none" stroke="#DBEAFE" strokeDasharray="3 6" />
        <ellipse cx="200" cy="240" rx="130" ry="190" fill="none" stroke="#DBEAFE" strokeDasharray="3 6" />
        <path d="M200,240 C 300,140 380,120 472,92" fill="none" stroke="rgba(37,99,235,0.55)" strokeWidth="1.4" strokeDasharray="5 9" className="animate-dashmove" />
        <path d="M200,240 C 330,260 420,300 505,338" fill="none" stroke="rgba(37,99,235,0.45)" strokeWidth="1.4" strokeDasharray="5 9" className="animate-dashmove" style={{ animationDelay: "-3s" }} />
        <path d="M200,240 C 150,140 120,100 58,64" fill="none" stroke="rgba(59,130,246,0.4)" strokeWidth="1.4" strokeDasharray="5 9" className="animate-dashmove" style={{ animationDelay: "-6s" }} />
        <path d="M200,240 C 280,330 320,370 392,404" fill="none" stroke="rgba(37,99,235,0.35)" strokeWidth="1.4" strokeDasharray="5 9" className="animate-dashmove" style={{ animationDelay: "-1.5s" }} />
        <Node x={200} y={240} accent label="IN" />
        <Node x={472} y={92} />
        <Node x={505} y={338} />
        <Node x={58} y={64} />
        <Node x={392} y={404} />
    </svg>
);

export default function Global() {
    return (
        <section data-testid="global-section" className="relative overflow-hidden border-t border-slate-200 bg-white py-24 sm:py-32">
            <div
                className="pointer-events-none absolute right-0 top-1/2 h-[420px] w-[420px] -translate-y-1/2 rounded-full bg-brand/[0.07] blur-[130px]"
                aria-hidden="true"
            />
            <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-4 sm:px-8 lg:grid-cols-2 lg:px-16">
                <Reveal>
                    <Eyebrow testId="global-eyebrow">Global</Eyebrow>
                    <h2 className="font-display text-3xl font-bold leading-[1.15] tracking-tight text-balance text-slate-900 sm:text-4xl lg:text-5xl">
                        Built in India. <span className="text-brand">Connected to the world.</span>
                    </h2>
                    <p className="mt-6 max-w-lg text-base leading-relaxed text-slate-600 sm:text-lg">
                        We work with businesses and teams across markets, combining global
                        product expectations with practical engineering.
                    </p>
                    <p className="mt-10 inline-flex items-center gap-4 rounded-full border border-brand/25 bg-brand-subtle px-5 py-3 font-mono text-xs font-semibold uppercase tracking-[0.25em] text-brand-dark">
                        India
                        <span className="h-px w-10 bg-brand" aria-hidden="true" />
                        Global
                    </p>
                </Reveal>
                <Reveal delay={0.15}>
                    <div data-testid="global-network-visual" className="relative rounded-2xl border border-brand/15 bg-gradient-to-br from-white to-blue-50/70 p-6 shadow-card sm:p-10">
                        <NetworkVisual />
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
